import { authAxios } from "@/api";
import { API_VER, ROOT_URL } from "@/setup/constants";

const API_CONTROLLER = "carrier";

export class CarrierApi {
    static getCarrierDetail(carrierId) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${carrierId}`;
        return authAxios.get(url);
    }

    static updateCarrierDetail(carrierId, carrierInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${carrierId}`;
        return authAxios.put(url, carrierInfo);
    }

    static createCarrier(carrierInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/`;
        return authAxios.post(url, carrierInfo);
    }

    static deleteCarrier(carrierId) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${carrierId}`;
        return authAxios.delete(url);
    }

    static getCarrierList(filterInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/search`;
        return authAxios.post(url, filterInfo);
    }
}